import axios, { type AxiosInstance } from "axios"
import { getExhibitionHeader } from "../utils/exhibitionContext";
import type { TodayPerformanceData, OverallPerformanceData, PersonPerformanceStats } from "../Component/Application/Performance/performance-types"

const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
})

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken")
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    Object.assign(config.headers, getExhibitionHeader());
    }
    return config
  },
  (error) => Promise.reject(error),
)

export const PerformanceService = {
  // FRONTEND ONLY - Today's staff performance
  getTodayStaffPerformance: async (): Promise<TodayPerformanceData> => {
    const response = await api.get("/api/entries/frontend/today-staff-performance/")
    return response.data
  },

  // FRONTEND ONLY - Overall staff performance (all days)
  getOverallStaffPerformance: async (): Promise<OverallPerformanceData> => {
    const response = await api.get("/api/entries/frontend/overall-staff-performance/")
    return response.data
  },

  // FRONTEND ONLY - Specific person performance stats
  getPersonPerformanceStats: async (userId: number): Promise<PersonPerformanceStats> => {
    const response = await api.get(`/api/entries/frontend/person-performance/${userId}/`)
    return response.data
  },
}

export default PerformanceService
